import React from "react";
import ssoStyles from "../../../assets/css/modules/containers/SSOContainer.css";


export default ({ children }) => (
  <div className={ssoStyles.background}>
    <div className={ssoStyles.bgimg}>
      <div className={ ssoStyles.bgimginner } />
    </div>
    <div className={ssoStyles.overlay} />
    <div className="container">
      <div className="row">
        <div className="col-sm-12">
          <div
            className={
              "col-md-10 offset-md-1 col-lg-6 offset-lg-3 " +
              ( ssoStyles.shadowBorder) +
             " " +
              ssoStyles.ssocontainer
            }
          >
            <div className={ ssoStyles.childrenContainer}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
